module.exports = __webpack_public_path__ + "static/media/westinchennai11.a3849a05.jpg";